export default __webpack_public_path__ + "static/media/bp-18.3a720cdb.jpg";